const utmSourceLogo = {
    mostt: '/images/mostt_logo.svg',
    lendkey: '/images/lendkey_logo.svg',
};

export {utmSourceLogo};
